import * as React from "react";
import type { SVGProps } from "react";

const SvgReorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={30}
    viewBox="0 0 25 30"
    {...props}
  >
    <path
      fill="#375481"
      fillRule="evenodd"
      d="M12.275 30C6.24 30 1.03 25.494.155 19.52a12.6 12.6 0 0 1-.114-1.764c-.007-.787.541-1.363 1.302-1.372.784 0 1.331.547 1.352 1.33.076 2.933 1.156 5.329 3.21 7.12 1.891 1.65 3.98 2.486 6.21 2.485 1.096 0 2.23-.206 3.368-.614 3.46-1.234 5.611-3.81 6.218-7.45a9.46 9.46 0 0 0-2.124-7.722c-1.764-2.066-4.366-3.29-7.135-3.357-.906-.022-2.222-.03-3.445-.03-.873 0-3.124.008-3.256.025l-.295.037-.1.272c-.113.319-.113.319 1.342 1.745.382.376.777.762 1.045 1.037.37.382.512.9.382 1.386-.12.445-.444.78-.892.917a1.6 1.6 0 0 1-.455.071c-.331 0-.616-.124-.874-.379A675 675 0 0 1 .415 7.772c-.557-.563-.553-1.354.01-1.924a651 651 0 0 1 5.45-5.45C6.135.14 6.473 0 6.825 0c.35 0 .685.138.941.39.533.524.537 1.371.005 1.93-.263.276-.87.77-1.404 1.206C5.09 4.563 4.895 4.724 5 5.096l.08.285.322.06c.094.008.562.008 1.254.01 1.594 0 4.408.003 5.87.028 6.078.1 11.199 4.74 11.91 10.792.784 6.671-3.783 12.645-10.397 13.6-.584.086-1.178.129-1.764.129"
    />
  </svg>
);
export default SvgReorder;
